exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js!./../css/variables.css"), "");

// module
exports.push([module.id, ".router-link-active[data-v-e85b5816]{background:var(--light_purple)}@media (min-width:769px){#page-header.headroom--unpinned[data-v-e85b5816]{transform:translate(-50%,-70px);height:135px;overflow:hidden}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-e85b5816","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/components/Header.vue
// module id = 412
// module chunks = 0